import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

// Suppress benign ResizeObserver loop error (triggered by Recharts/Leaflet)
const resizeObserverErr = window.onerror;
window.onerror = (message, ...args) => {
  if (typeof message === "string" && message.includes("ResizeObserver loop")) return true;
  if (resizeObserverErr) return resizeObserverErr(message, ...args);
};
window.addEventListener("error", (e) => {
  if (e.message?.includes("ResizeObserver loop")) e.stopImmediatePropagation();
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
